import type { AxiosRequestConfig } from 'axios';
import axiosClient from '@/actions/axios-client';
import { toApiResponseError } from './normalize-error';

async function unwrap<T>(p: Promise<{ data: T }>): Promise<T> {
  try {
    const r = await p;
    return r.data;
  } catch (e) {
    throw toApiResponseError(e);
  }
}

/**
 * Thin axios facade — returns response **data** only and throws {@link ApiResponseError}.
 * Method signatures mirror legacy `base[verb](url, requestOptions, body)` helpers.
 */
export const base = {
  get: <T>(url: string, requestOptions?: object) =>
    unwrap<T>(axiosClient.get(url, requestOptions as AxiosRequestConfig)),

  post: <T>(url: string, requestOptions: object | undefined, body: unknown) =>
    unwrap<T>(
      axiosClient.post(url, body, requestOptions as AxiosRequestConfig),
    ),

  put: <T>(url: string, requestOptions: object | undefined, body: unknown) =>
    unwrap<T>(axiosClient.put(url, body, requestOptions as AxiosRequestConfig)),

  delete: <T>(
    url: string,
    requestOptions: object | undefined,
    body?: unknown,
  ) =>
    unwrap<T>(
      axiosClient.delete(url, {
        ...(requestOptions as AxiosRequestConfig),
        ...(body !== undefined ? { data: body } : {}),
      }),
    ),
};

export default base;
